export interface System {
  Error: boolean;
  Message: string;
  systems?: SystemsEntity[] | null;
  system?: number;
}
export interface SystemsEntity {
  id: number;
  name: string;
  design_id: number;
}

export interface SingleSystemModel {
  Error?: boolean;
  Message?: string;
  system?: singleSystem[] | null;
}
export class singleSystem {
  id: number;
  name: string;
  design_id: string;
  radio1: string;
  ventairrate: string;
  venairflo0: number;
  runtimecyc: string;
  cycletimes: string;
  specifiedsystype: string;
  contlocspe: string;
  opwointrvntn: string;
  ventoverride: string;
  useintakeright: string;
  fanratedsones: string;
  fanreducevnt: string;
  bathroomfanses: string;
  inletpullsoutdr: string;
  inletlocation: string;
  dessheatgainn?: null;
  dessheatgainne?: null;
  dessheatgaine?: null;
  dessheatgainse?: null;
  dessheatgains?: null;
  dessheatgainsw?: null;
  dessheatgainw?: null;
  dessheatgainnw?: null;
  maxheatgain: number;
  deslheatgain?: number;
  destotlheatgainn?: number;
  destotlheatgainne?: number;
  destotlheatgaine?: number;
  destotlheatgainse?: number;
  destotlheatgains?: number;
  destotlheatgainsw?: number;
  destotlheatgainw?: number;
  destotlheatgainnw?: number;
  maxtotal: number;
  desttotlheatloss: string;
  mansmethod?: null;
  coolsizingpct: number;
  coolingsizinglimit: string;
  coolsizepctlimit?: null;
  heatsizinglimit: string;
  heatsizepctlimit?: null;
  coolsizepctlimit2: string;
  coolsizepctlimit3: string;
  heatsizepctlimits: number;
  heatsizepctlimits2: string;
  heatsizepctlimits3: string;
  hrt?: any ;
  manuald: string;
  designairflowcool: string;
  hvacfanspdcool: string;
  hvacfanspdheat: string;
  designstaticp: string;
  equipment_id: string;
  designairflowheat: string;
  gfh?: number;
  hvac_design_id?: number | string;
  systemcomplete?: boolean;
  completesystems?: boolean;
}

export class Room {
  dsh_heat_flow?: string;
  room_descr?: string;
  hvac_design_id?: string;
  selection_id?: string;
}
